export const MAX_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 20;
